export default {
  getQuote : (state) => state.quote,
  getQuoteItems : (state) => state.quoteItems,
  getQuoteBookings : (state) => state.quoteBookings,
  getOrderQuote : (state) => state.orderQuote,
  getQuoteConfiguration : (state) => state.quoteConfiguration,
}
